import React from "react";
import { View, ViewStyle, StyleSheet } from "react-native";
import { Button } from "@/components/ui/Button";
import { useTheme } from "@/hooks/useTheme";

export interface ToggleButtonGroupOption {
  text: string;
  value: string;
}

export interface ToggleButtonGroupProps {
  options: ToggleButtonGroupOption[];
  value: string;
  onChange: (value: string) => void;
  style?: ViewStyle;
  label?: string;
}

export function ToggleButtonGroup({ options, value, onChange, style, label }: ToggleButtonGroupProps) {
  const { colors } = useTheme();

  return (
    <View style={[styles.container, style]}>
      {label && <View style={styles.labelContainer}>{/* Label can be added if needed */}</View>}
      <View style={styles.buttonGroup}>
        {options.map((option) => (
          <Button
            key={option.value}
            text={option.text}
            style={[
              styles.button,
              {
                backgroundColor: value === option.value ? colors.primary : "transparent",
                borderColor: value === option.value ? colors.primary : colors.border,
              },
            ]}
            textStyle={{
              color: value === option.value ? "white" : colors.text,
              fontSize: 13,
            }}
            onPress={() => onChange(option.value)}
          />
        ))}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    gap: 4,
  },
  labelContainer: {
    marginBottom: 4,
  },
  buttonGroup: {
    flexDirection: "row",
    gap: 8,
  },
  button: {
    height: 32,
    paddingHorizontal: 16,
    borderWidth: 1,
  },
});
